import './bookmarkColumnControl.scss';
import React from 'react';
import {BaseCol} from './base-col';
import {useSearchPageType} from '../../../../search-hooks';
import {ColumnControlProps} from '../search-result-item-types';
import {useDispatch} from 'react-redux';
import {ProdDocument} from '../../../../search-types';
import {addBookmark, removeBookmark} from '../../../../../services/search-service';
import {Icons} from '../../../../../icons/icons';
import {HibuButton} from '../../../../../common/hibuButton/hibuButton';

export const BookmarkColumnControl = ({doc}: ColumnControlProps): React.JSX.Element => {
    const searchPageType = useSearchPageType();
    const dispatch = useDispatch();
    const active: boolean = doc.metadata.bookmarked;

    const onBookmarkClicked = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.stopPropagation();
        if (active) {
            dispatch(removeBookmark(searchPageType, doc as ProdDocument));
        } else {
            dispatch(addBookmark(searchPageType, doc as ProdDocument));
        }
    };

    return (
        <BaseCol className={'document-column-bookmark'}>
            <HibuButton
                visible
                onClick={onBookmarkClicked}
                icon={Icons.STAR}
                className={active ? 'bookmark active' : 'bookmark'}
                tooltipKey={active ? 'search.bookmark.remove' : 'search.bookmark.add'}
            />
        </BaseCol>
    );
};
